import API from 'services/api.js';
import { URL_GET_TIMEZONES } from 'services/urls.js';
export const SET_TIMEZONES = 'SET_TIMEZONES';
export const SET_TIMEZONES_LOADED = 'SET_TIMEZONES_LOADED';

export const actionFetchTimezonesSuccess = (data) => {
	return {
		type: SET_TIMEZONES,
		data,
	};
};

export const actionSetTimezonesLoaded = (data) => {
	// data is true or false
	return {
		type: SET_TIMEZONES_LOADED,
		data,
	};
};

export const actionFetchTimezones = (setWloading, showMessage) => {
	return (dispatch) => {
		const params = {
			params: {
				//clientId: clientId,
			},
			headers: {
				//'x-opw-format': 'list',
			},
		};
		//	/api/weigherIds/<ClientID>
		let resp = null;
		return API.get(URL_GET_TIMEZONES, params)
			.then((response) => {
				resp = response.data;
			})
			.catch((error) => {
				console.log('error', error);
				showMessage('Err fetching timezones: ' + error);
				resp = [];
			})
			.then(() => {
				setWloading(false);
				dispatch(actionSetTimezonesLoaded(true));
				dispatch(actionFetchTimezonesSuccess(resp));
				//return resp
			});
	};
};
